import React from 'react';
import './style.scss';
export default function CustomLinkOnCLick(props) {
	return (
		<>
			<div {...props} />
		</>
	);
}
